import { api } from "@/redux/api";

import { CreateSwarm, Swarm, SwarmSchema } from "../../pages/Swarm/schema/swarm";
import {
	SwarmPreviewResponseSchema,
	SwarmPreviewResponse,
} from "../../pages/Swarm/schema/swarmPreview";

export const swarmApi = api.injectEndpoints({
	endpoints: (builder) => ({
		createSwarm: builder.mutation<Swarm, CreateSwarm>({
			query: (body) => ({
				url: `swarm`,
				method: "POST",
				body,
				responseSchema: SwarmSchema,
			}),
			invalidatesTags: (result, error, arg) => {
				if (arg.listId) {
					return [{ type: "List", id: arg.listId }, "Swarm"];
				}

				return ["Swarm"];
			},
		}),
		previewSwarm: builder.mutation<SwarmPreviewResponse, CreateSwarm>({
			query: (body) => ({
				url: `swarm/preview`,
				method: "POST",
				body,
				responseSchema: SwarmPreviewResponseSchema,
			}),
		}),
		updateSwarm: builder.mutation<Partial<Swarm>, Partial<Swarm> & { listId?: number }>({
			query: ({ id, ...body }) => ({
				url: `swarm/${id}`,
				method: "PATCH",
				body,
				responseSchema: SwarmSchema,
			}),
			invalidatesTags: (result, error, arg) => {
				if (arg.listId) {
					return [{ type: "List", id: arg.listId }, "Swarm"];
				}

				return ["Swarm"];
			},
		}),
		deleteSwarm: builder.mutation<{ id: number }, { id: number; listId?: number }>({
			query: ({ id }) => ({
				url: `swarm/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: (result, error, arg) => {
				if (arg.listId) {
					return [{ type: "List", id: arg.listId }, "Swarm"];
				}

				return ["Swarm"];
			},
		}),
	}),
});

export const {
	useCreateSwarmMutation,
	useUpdateSwarmMutation,
	useDeleteSwarmMutation,
	usePreviewSwarmMutation,
} = swarmApi;
export const swarmApiReducer = swarmApi.reducer;
export const swarmApiMiddleware = swarmApi.middleware;
